import { CloudDownloadOutlined, RefreshOutlined, RemoveRedEyeOutlined } from "@material-ui/icons";
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../../../../hooks/useToast";
import useConfirm from "../../../../hooks/useConfirm";
import SearchIcon from "@mui/icons-material/Search";
import { RecrutementService } from "../../../../service/admin_service/RecrutementService";
import { FileDownloadOutlined } from "@mui/icons-material";
import VerticalAlignBottomOutlinedIcon from "@mui/icons-material/VerticalAlignBottomOutlined";
import { SQCReponseService } from "../../../../service/SQC_form/SQCReponseService";
import { handleExportExcel } from "./RecrutementPage";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import useContextMenu from "../../../../hooks/useContextMenu";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import {
  exportMultipleSheetsToExcelJS,
  exportToExcelJS,
  transformeDataHeaderToExcelColonne,
} from "../../../../Helpers/ExcelJsHelper";
import { AMIService } from "../../../../service/AMI/AMIService";
import { useToastStore } from "../../../../stores/toastStore";

const AgexOffreList = ({ selection = false, id_type, handleSelectedCV }) => {
  const showToastStore = useToastStore((state) => state.showToast);
  const [offres, setOffres] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const navigate = useNavigate();
  const [dataLoading, setDataLoading] = useState(false);
  const { Toast, showToast } = useToast();
  const [idsButtonLoading, setIdsButtonLoading] = useState([]);
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { openMenu, MenuComponent } = useContextMenu([
    {
      icon: <FileDownloadOutlined />,
      label: "Telechager reponses",
      color: "primary",
      action: (row) => handleDownloadExcel(row.id_type, row.libelle_type),
    },
    {
      icon: <FileDownloadOutlined />,
      label: "Telecharger expériences",
      color: "primary",
      action: (row) =>
        handleDownloadExcelExperiences(row.id_type, row.libelle_type),
    },
  ]);

  const handleShowCandidatList = (id) => {
    navigate(`agex?offre_id=${id}`);
  };

  const handleFetchAgexOffreList = () => {
    setDataLoading(true);
    RecrutementService.getFilteredOffre({ type: "externe", desc: "AGEX" })
      .then((res) => {
        if (res && res.data) {
          setOffres(res.data);
          setFilteredRows(res.data);
        } else {
          setOffres([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleDownloadPj = (id_type, newFileName = "Documents_AMI") => {
    setIdsButtonLoading((prev) => [...prev, "zip_export" + id_type]);
    showToast(
      TYPE_NOTIFICATION.INFO,
      "Téléchargement en cours...<br/><a href='" +
        process.env.REACT_APP_API_BASE_URL +
        "/volontariat/Ami/telecharger_tout_zip?id_type=" +
        id_type +
        "' target='_blank'>cliquer ici si le telechargement ne demarre pas</a>",
      15000,
    );
    AMIService.downloadAllPj({ id_type: id_type })
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          console.log(response.headers);
          const fileName =
            response.headers["Content-Disposition"]
              ?.split("filename=")[1]
              ?.replace(/['"]/g, "") || newFileName + ".zip";
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
        }
      })
      .finally(() => {
        setIdsButtonLoading((prev) =>
          prev.filter((id) => id !== "zip_export" + id_type),
        );
      })
      .catch((error) => {
        showToast(TYPE_NOTIFICATION.ERROR, "Erreur de téléchargement.");
      });
  };

  const handleDownloadExcel = useCallback(
    (id_type, titre = null) => {
      setIdsButtonLoading((prev) => [...prev, "excel_export" + id_type]);
      SQCReponseService.getReponsesListByTypeAndFormId(id_type)
        .then((res) => {
          if (res && res.data) {
            handleExportExcel(res.data, titre);
          } else {
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .finally(() => {
          setIdsButtonLoading((prev) =>
            prev.filter((id) => id !== "excel_export" + id_type),
          );
        });
    },
    [id_type],
  );
  const handleDownloadExcelExperiences = useCallback(
    (id_type, titre = null) => {
      setIdsButtonLoading((prev) => [...prev, "excel_export_exp" + id_type]);
      AMIService.getExperiencesList({ id_type: id_type })
        .then((res) => {
          if (res) {
            if (res && res.data) {
              if (Array.isArray(res.data) && res.data.length > 0) {
                exportToExcelJS(
                  res.data,
                  transformeDataHeaderToExcelColonne(res.data),
                  titre || "Résumé des réponses par AMI",
                );
              } else {
                showToast(TYPE_NOTIFICATION.ERROR, "Aucune donnée à exporter");
              }
            } else {
              showToast(TYPE_NOTIFICATION.ERROR, res.message);
            }
          }
        })
        .finally(() => {
          setIdsButtonLoading((prev) =>
            prev.filter((id) => id !== "excel_export" + id_type),
          );
        });
    },
    [id_type],
  );
  const handleDownloadExcelExperiencesAndReponses = useCallback(
    (id_type, titre = null) => {
      setIdsButtonLoading((prev) => [...prev, "excel_export_exp" + id_type]);
      AMIService.getExperiencesAndReponsesList({ id_type: id_type })
        .then((res) => {
          if (res) {
            if (res && res.data) {
              exportMultipleSheetsToExcelJS(
                res.data,
                titre || "Résumé des réponses par AMI",
              );
            } else {
              showToast(TYPE_NOTIFICATION.ERROR, res.message);
            }
          }
        })
        .finally(() => {
          setIdsButtonLoading((prev) =>
            prev.filter((id) => id !== "excel_export_exp" + id_type),
          );
        });
    },
    [id_type],
  );

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(offres);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      offres.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot),
          ),
        ),
      ),
    );
  };

  const table_colonne = [
    {
      field: "description",
      headerName: "Réference",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "libelle_type",
      headerName: "Titre",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "date_debut_publication",
      headerName: "Date de création",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "date_fin_publication",
      headerName: "Date de cloture",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "nbr",
      headerName: "Postulant",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Afficher les postulants"
              color="primary"
              onClick={(e) => handleShowCandidatList(params.row.id_type)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
            <IconButton
              loading={idsButtonLoading.includes(
                "excel_export_exp" + params.row.id_type,
              )}
              title="Exporter en excel les reponses aux formulaires sur l'offre selectionnées"
              color="primary"
              onClick={(e) =>
                handleDownloadExcelExperiencesAndReponses(
                  params.row.id_type,
                  params.row.libelle_type,
                )
              }
            >
              <VerticalAlignBottomOutlinedIcon />
            </IconButton>
            <IconButton
              loading={idsButtonLoading.includes(
                "zip_export" + params.row.id_type,
              )}
              title="Télécharger les pieces jointes et attestation de bonne fin envoyés"
              color="primary"
              onClick={(e) =>
                handleDownloadPj(params.row.id_type, params.row.libelle_type)
              }
            >
              <CloudDownloadOutlined />
            </IconButton>
            <IconButton
              sx={{ display: "none" }}
              loading={idsButtonLoading.includes(
                "excel_export" + params.row.id_type,
              )}
              title="Exporter en excel les reponses aux formulaires sur l'offre selectionnées"
              color="primary"
              onClick={(e) => openMenu(e, params.row)}
            >
              <MoreVertOutlinedIcon />
            </IconButton>
            <MenuComponent />
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchAgexOffreList();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Offre pour les AGEX"
              action={
                <Grid container spacing={1}>
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      onClick={handleFetchAgexOffreList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                rows={filteredRows}
                getRowId={(row) => row.id_type}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default AgexOffreList;
